export default __webpack_public_path__ + "static/media/Morph Decaying Corpse.8b22653e.jpg";